import { hasOrganizationLinkedInCompany } from '~/utils/linkedinCompany'

export const namespaced = true

export const getDefaultState = () => ({
	selectedJobOffer: null,
	showActivateJobModal: false
})

export const state = () => getDefaultState()

export const getters = {
	selectedJobOffer(state) {
		return state.selectedJobOffer
	},
	showJobOfferModal(state) {
		return state.showActivateJobModal
	}
}

export const mutations = {
	RESET_STATE(state) {
		Object.assign(state, getDefaultState())
	},
	TOGGLE_MULTIPOSTING(state, value) {
		if (!state.selectedJobOffer) {
			return
		}

		state.selectedJobOffer = {
			...state.selectedJobOffer,
			multiposting: value
		}
	},
	SET_SELECTED_JOB_OFFER(state, payload) {
		state.selectedJobOffer = {
			...payload,
			multiposting: true
		}
	},
	UNSET_SELECTED_JOB_OFFER(state) {
		state.selectedJobOffer = null
	},
	OPEN_JOB_OFFER_MODAL(state) {
		state.showActivateJobModal = true
	},
	CLOSE_JOB_OFFER_MODAL(state) {
		state.showActivateJobModal = false
	}
}

export const actions = {
	async activateJobOffer({ state, dispatch, rootState }) {
		const jobName = state.selectedJobOffer?.name || ''
		const successToast = {
			title: this.app.i18n.t('job-offer.toast.activate-job.heading', {
				job: jobName
			}),
			message: state.selectedJobOffer?.multiposting
				? hasOrganizationLinkedInCompany(
						rootState.user?.user?.current_organization
				  )
					? this.app.i18n.t(
							'job-offer.toast.activate-job.body.with-linkedin',
							{ job: jobName }
					  )
					: this.app.i18n.t(
							'job-offer.toast.activate-job.body.posted-without-linkedin',
							{ job: jobName }
					  )
				: this.app.i18n.t(
						'job-offer.toast.activate-job.body.without-linkedin',
						{ job: jobName }
				  ),
			type: 'success'
		}

		let updatedJobOffer = null
		try {
			updatedJobOffer = await dispatch(
				'jobOffer/activate',
				{
					id: state.selectedJobOffer.id,
					multiposting: Boolean(state.selectedJobOffer.multiposting),
					successToast
				},
				{ root: true }
			)
		} catch {
			// Error toast already shown by jobOffer/activate; keep modal open for retry
			return
		}

		const isPublished = Boolean(updatedJobOffer?.active)

		if (isPublished && process.client && this.app.$analytics) {
			const user = rootState.user?.user
			const organizationId = user?.current_organization?.id
			if (organizationId) {
				this.app.$analytics.trackJobPublished({
					organizationId,
					userId: user?.id,
					jobOfferId: state.selectedJobOffer?.id,
					sourceSurface: 'activate_job_modal'
				})
			}
		}

		if (isPublished) {
			await dispatch('closeJobOfferModal')
		}
	},
	async deactivateJobOffer({ dispatch }, payload) {
		const jobOffer = payload?.jobOffer || payload
		const suppressToast = payload?.suppressToast || false
		const jobName = jobOffer?.name || ''
		const successToast = {
			title: this.app.i18n.t('job-offer.toast.deactivate-job.heading', {
				job: jobName
			}),
			message: this.app.i18n.t('job-offer.toast.deactivate-job.body', {
				job: jobName
			}),
			type: 'success'
		}

		return await dispatch(
			'jobOffer/deactivate',
			{
				id: jobOffer?.id,
				suppressToast,
				successToast
			},
			{ root: true }
		)
	},
	toggleMultiposting({ commit }, value) {
		commit('TOGGLE_MULTIPOSTING', value)
	},
	setSelectedJobOffer({ commit }, payload) {
		commit('SET_SELECTED_JOB_OFFER', payload)
	},
	unsetSelectedJobOffer({ commit }) {
		commit('UNSET_SELECTED_JOB_OFFER')
	},
	openJobOfferModal({ dispatch, commit }, payload) {
		dispatch('setSelectedJobOffer', payload)
		commit('OPEN_JOB_OFFER_MODAL')
	},
	closeJobOfferModal({ dispatch, commit }) {
		dispatch('unsetSelectedJobOffer')
		commit('CLOSE_JOB_OFFER_MODAL')
	}
}
